import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { EditTemplateComponent } from './dialogs/edit/edit.component';
import { TemplatesComponent } from './templates.component';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';

import { TemplatesRoutingModule } from './templates.routing.module';
import { ViewComponent } from './view/view.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { SearchComponent } from './search/search.component';
@NgModule({
  declarations: [TemplatesComponent,
    EditTemplateComponent,
    ViewComponent,
    SearchComponent],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ResourcefulIndexModule,
    CustomFormControlsModule,
    TemplatesRoutingModule,
    NgxExtendedPdfViewerModule,
  ],
  exports: [TemplatesComponent,
    EditTemplateComponent,]
})
export class TemplatesModule { }
